export default {
  computed: {
    isFlipped() {
      return Boolean(this.$store.state.query.flip)
    },
  },
}
